import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

const { BULK_BIDDING } = ANALYTICS_CATEGORIES;
const { CLICK } = SNOWPLOW_EVENTS;

export const triggerBulkBiddingDealerUploadedFile = (): void => {
	const eventPayload = getSnowplowEventPayload({
		category: BULK_BIDDING,
		name: 'dlr_bulk_bidding_dealer_uploaded_file',
		schemaName: CLICK.SCHEMA,
		version: CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
